<template>
  <div class="home">
    <img v-if="isOnly" src="../../assets/image/only.png" />
    <img v-if="isLinlu" src="../../assets/image/linlu.png" />
    <img v-if="!isOnly && !isLinlu" src="../../assets/image/yiban.png" />
    <p class="home-title">欢迎使用{{ isOnly?'Only':isLinlu?'林鹿':'一伴' }}管理系统</p>
    <p class="home-tip">welcome to {{ isOnly?'Only':isLinlu?'Linlu':'yiban' }} management system</p>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {
      isOnly: false,
      isLinlu: false,
    }
  },
  mounted() {
    if(window.location.hostname == 'only.backstage.yiban1314.com' ) {
      this.isOnly = true
    }
    if(window.location.hostname == 'backstage.youban1314.cn'  || window.location.port == '20030' ) {
      this.isLinlu = true
    }
  }
}
</script>

<style scoped>
.home {
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 48px);
}
.home-title {
  font-weight: bolder;
  font-size: 28px;
  color: #001c37;
  letter-spacing: 1px;
}
.home-tip {
  font-size: 12px;
  color: #bbbbbb;
}
.home img {
  width: 200px;
  height: 200px;
  margin-top: -100px;
}
</style>
